import apiClient from './apiClient';

export type DerivedConstructionStatus =
  | 'planned'
  | 'in_progress'
  | 'blocked'
  | 'remedial'
  | 'completed'
  | 'handover_ready';

export interface UnitStatusRow {
  id: string;
  code: string;
  name: string;
  unitType: string | null;
  floorNumber: number | null;
  areaSqm: number | null;

  buildingId: string;
  buildingCode: string;
  buildingName: string;
  blockId: string;
  blockCode: string;
  blockName: string;
  phaseId: string;
  phaseName: string;

  saleStatus: string;
  targetSalePrice: number | null;
  actualSalePrice: number | null;
  targetHandoverDate: string | null;
  actualHandoverDate: string | null;

  taskCount: number;
  taskCountActive: number;
  taskCountBlocked: number;
  taskCountInspectionPassed: number;
  taskCountCancelled: number;
  completionPercentage: number;
  openDefectCount: number;
  hasRemedialOpen: boolean;

  saleContractId: string | null;
  saleContractNumber: string | null;
  saleContractBuyerName: string | null;
  saleContractStatus: string | null;

  constructionStatus: DerivedConstructionStatus;
}

export interface UnitStatusGroup {
  buildingId: string;
  buildingCode: string;
  buildingName: string;
  blockId: string;
  blockCode: string;
  blockName: string;
  phaseId: string;
  phaseName: string;
  unitCount: number;
  byStatus: Record<DerivedConstructionStatus, number>;
}

export interface UnitStatusMap {
  units: UnitStatusRow[];
  groups: UnitStatusGroup[];
  totals: {
    unitCount: number;
    byConstructionStatus: Record<DerivedConstructionStatus, number>;
    bySaleStatus: Record<string, number>;
  };
}

class UnitService {
  async getStatusMap(projectId: string): Promise<UnitStatusMap> {
    const response: any = await apiClient.get(`/units/project/${projectId}/status-map`);
    return response.data;
  }
}

export default new UnitService();
